export default {
  header: {
    title: 'Comprar cartão de oferta',
  },
  checkout_btn: {
    title: 'Checkout',
    max_quantity: 'No máximo {{max}} cartões-presente por compra',
  },
  items: {
    gift_card: {
      online: 'Cartão de oferta resgatável apenas online',
      online_and_store: 'Cartão de oferta (resgatável online e na loja)',
      title: 'Selecione o valor pretendido',
      description: 'Adicione o cartão de oferta com a quantidade pretendida ao carrinho',
    },
    expiration: {
      label: 'Válido por 3 anos',
      title: 'Bom presente!',
      description: 'O destinatário pode resgatar o voucher de forma flexível em 3 anos.',
    },
    delivery: {
      label: 'Entrega imediata em PDF por e-mail',
      title: 'Entrega imediata em PDF por e-mail',
      description: 'Após pagamento seguro, receberá o voucher imediatamente.',
    },
  },
  form: {
    value: {
      title: 'Escolha o valor do cartão de oferta',
      custom: {
        label: 'Personalizado',
        placeholder: 'Introduza um valor entre {{min}} e {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Quantidade',
    },
    email: {
      title: 'Qual é o seu e-mail para enviarmos o cartão de oferta?',
      placeholder: 'O seu endereço de e-mail',
      error: 'E-mail inválido',
    },
  },
  confirmation: {
    title: {
      title: 'Comprar cartão de oferta?',
      subtitle_one: 'Deseja comprar 1 cartão de oferta por {{value}}?',
      subtitle_other: 'Deseja comprar {{count}} cartões de oferta por {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'E-mail:',
      quantity: 'Quantidade',
      amount: 'Valor',
    },
    footer: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
  },
};
